@if (showShell) {
    <nav class="navbar-default navbar-static-top">
        <div class="container">
            <div class="navbar-header">
                <a class="navbar-brand" routerLink="/search">
                    <img src="assets/images/pfwhite.svg" alt="PerForma" />
                </a>
            </div>
        </div>
        <div class="navbar-border">
            <div class="container container-menu">
                <div id="navbar" class="navbar-collapse">
                    <ul class="nav navbar-nav">
                        @for (item of navItems; track item.link) {
                            <li routerLinkActive="active">
                                <a [routerLink]="item.link">{{ item.label }}</a>
                            </li>
                        }
                    </ul>
                    <ul class="nav navbar-nav navbar-right">
                        <li>
                            <a routerLink="/profile"><i class="fa-solid fa-user"></i>&nbsp;{{ username }}</a>
                        </li>
                        @if (canConfigure) {
                            <li>
                                <a routerLink="/configure"><i class="fa-solid fa-gear"></i>&nbsp;Settings</a>
                            </li>
                        }
                        <li>
                            <a class="logout-link" href="javascript:void(0);" aria-label="Logout" (click)="logout()">
                                <i class="fa-solid fa-power-off"></i>&nbsp;Logout
                            </a>
                        </li>
                        <li class="dropdown">
                            <a target="_blank" style="font-size: 18px" href="assets/manual.pdf">?</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>

    @if (showPasswordWarning) {
        <div class="alert alert-warning password-warning" role="alert">
            Your password expires in {{ passwordWarningDays }} days -
            <a class="text-danger" routerLink="/profile/password">change it here</a>
        </div>
    }

    <router-outlet></router-outlet>

    <footer class="container">
        <div class="col-md-8 copyright">&copy; {{ year }} Sedona Technologies</div>
        <div class="col-md-4 links">
            <a [href]="supportUrl" target="_blank">Support</a>
            <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <a href="assets/license.pdf" target="_blank">License</a>
            <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <a routerLink="/about">About</a>
            @if (version) {
                <span>&nbsp;&nbsp;|&nbsp;&nbsp;v{{ version }}</span>
            }
        </div>
    </footer>
} @else if (showAuthHeader) {
    <nav class="navbar-default navbar-static-top">
        <div class="container">
            <div class="navbar-header">
                <a class="navbar-brand" routerLink="/account/login">
                    <img src="assets/images/pfwhite.svg" alt="PerForma" />
                </a>
            </div>
        </div>
        <div class="navbar-border">
            <div class="container container-menu">
                <div id="navbar" class="navbar-collapse"></div>
            </div>
        </div>
    </nav>

    <router-outlet></router-outlet>

    <footer class="container">
        <div class="col-md-8 copyright">&copy; {{ year }} Sedona Technologies</div>
        <div class="col-md-4 links">
            @if (version) {
                <span>v{{ version }}</span>
            }
        </div>
    </footer>
} @else {
    <router-outlet></router-outlet>
}

<!-- shared content template for [safeTooltip]: ng-zorro escapes string content, so HTML is
     rendered here via [innerHTML] (Angular-sanitized) inside the tooltip -->
<ng-template #safeTooltipContent let-html><div [innerHTML]="html"></div></ng-template>
